import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "essential" }
const _hoisted_2 = { class: "checkbox-group" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  checked: "",
  disabled: "",
  id: "essential-box"
}, null, -1)
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "functional" }
const _hoisted_7 = { class: "checkbox-group" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "marketing" }
const _hoisted_11 = { class: "checkbox-group" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "button-bar" }

import { ref, onMounted } from 'vue'
import { marked } from 'marked'
import { GD, Storage, STORE_NAME } from '@gd/storage'
import { ACTION } from '@gd/tracking'
import { postSettings } from '../lib/request'
import { track } from '../lib/track'
import { events } from '@gd/event-bus'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConsentSettings',
  emits: ['close'],
  setup(__props, { emit }) {



const storage = new Storage()
const functionalActive = ref(true)
const marketingActive = ref(false)

const cookieConsent = (storage.read(STORE_NAME.GD) as GD).cookieConsent
if (cookieConsent && cookieConsent.consented) {
  functionalActive.value = cookieConsent.functional
  marketingActive.value = cookieConsent.marketing
}

onMounted(() => {
  track({
    id: 'consent_settings',
    action: ACTION.show,
  })
})

function md(text: string) {
  return marked(text)
}

function onConfirmCustomClick() {
  submitSelection({ functional: functionalActive.value, marketing: marketingActive.value })
  track({
    id: 'consent_settings',
    elem: 'button_consent_custom',
    action: ACTION.click,
  })
}

function onConfirmAllClick() {
  submitSelection({ functional: true, marketing: true })
  track({
    id: 'consent_settings',
    elem: 'button_consent_all',
    action: ACTION.click,
  })
}

function submitSelection(data: GD_cookieConsent.CookieConsentPost) {
  postSettings(data)
    .then(() => {
      let eventPayload = { functional: data.functional, marketing: data.marketing }
      events.$emit('cookie-consent', eventPayload)
      emit('close')
    })
    .catch(() => {
      emit('close')
    })
}

return (_ctx: any,_cache: any) => {
  const _component_t_toggle_box = _resolveComponent("t-toggle-box")!
  const _component_t_text = _resolveComponent("t-text")!
  const _component_t_button = _resolveComponent("t-button")!
  const _component_t_container = _resolveComponent("t-container")!

  return (_openBlock(), _createBlock(_component_t_container, {
    class: "consent-settings",
    "data-qe-id": "consent-settings"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_t_text, { class: "content" }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('cookieConsent.main.title')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('cookieConsent.main.text')), 1),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('cookieConsent.categoryEssential.title')), 1),
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("label", {
                innerHTML: _ctx.$t('cookieConsent.categoryEssential.text'),
                onClick: () => {},
                for: "essential-box",
                "data-qe-id": "essential-accept-desc"
              }, null, 8, _hoisted_4)
            ]),
            _createVNode(_component_t_toggle_box, {
              title: _ctx.$t('cookieConsent.main.moreinfo_textlink'),
              "qe-id": "xxx"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  innerHTML: md(_ctx.$t('cookieConsent.categoryEssential.details_md'))
                }, null, 8, _hoisted_5)
              ]),
              _: 1
            }, 8, ["title"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('cookieConsent.categoryFunctional.title')), 1),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((functionalActive).value = $event)),
                id: "functional-box"
              }, null, 512), [
                [_vModelCheckbox, functionalActive.value]
              ]),
              _createElementVNode("label", {
                innerHTML: _ctx.$t('cookieConsent.categoryFunctional.text'),
                onClick: () => {},
                for: "functional-box",
                "data-qe-id": "functional-accept-desc"
              }, null, 8, _hoisted_8)
            ]),
            _createVNode(_component_t_toggle_box, {
              title: _ctx.$t('cookieConsent.main.moreinfo_textlink'),
              "qe-id": "xxx"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  innerHTML: md(_ctx.$t('cookieConsent.categoryFunctional.details_md'))
                }, null, 8, _hoisted_9)
              ]),
              _: 1
            }, 8, ["title"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('cookieConsent.categoryMarketing.title')), 1),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((marketingActive).value = $event)),
                id: "marketing-box"
              }, null, 512), [
                [_vModelCheckbox, marketingActive.value]
              ]),
              _createElementVNode("label", {
                innerHTML: _ctx.$t('cookieConsent.categoryMarketing.text'),
                onClick: () => {},
                for: "marketing-box",
                "data-qe-id": "marketing-accept-desc"
              }, null, 8, _hoisted_12)
            ]),
            _createVNode(_component_t_toggle_box, {
              title: _ctx.$t('cookieConsent.main.moreinfo_textlink'),
              "qe-id": "xxx"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  innerHTML: md(_ctx.$t('cookieConsent.categoryMarketing.details_md'))
                }, null, 8, _hoisted_13)
              ]),
              _: 1
            }, 8, ["title"])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_t_button, {
          class: "consent-button accept-all",
          midGreen: "",
          onClick: onConfirmAllClick,
          "data-qe-id": "button-all"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('cookieConsent.main.button_1')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_t_button, {
          class: "consent-button accept-custom",
          yellow: "",
          onClick: onConfirmCustomClick,
          "data-qe-id": "button-custom"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('cookieConsent.main.button_2')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})